<!-- Modal Backdrop -->
<div
  class="modal fade"
  [class.show]="isOpen()"
  [style.display]="isOpen() ? 'block' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
  (click)="onBackdropClick($event)"
  (keydown)="onKeydown($event)"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title d-flex align-items-center gap-2">
          <i class="bi bi-download"></i>
          {{ config.title }}
        </h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
          [disabled]="isExporting()"
        ></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- Description -->
        <p *ngIf="config.description" class="text-muted mb-4">{{ config.description }}</p>

        <!-- Format Selection -->
        <div class="mb-4">
          <label class="form-label fw-medium">Export Format</label>
          <div class="format-options d-flex gap-2">
            <button
              *ngFor="let format of config.formats"
              type="button"
              class="btn format-btn"
              [class.btn-primary]="selectedFormat === format"
              [class.btn-outline-secondary]="selectedFormat !== format"
              (click)="selectedFormat = format"
            >
              <i class="bi me-1" [ngClass]="getFormatIcon(format)"></i>
              {{ getFormatLabel(format) }}
            </button>
          </div>
        </div>

        <!-- Date Range (Optional) -->
        <div class="mb-4" *ngIf="config.showDateRange">
          <div class="form-check mb-2">
            <input
              class="form-check-input"
              type="checkbox"
              id="dateRangeEnabled"
              [(ngModel)]="dateRangeEnabled"
            >
            <label class="form-check-label" for="dateRangeEnabled">
              Filter by date range
            </label>
          </div>

          <div class="row g-2" *ngIf="dateRangeEnabled">
            <div class="col-6">
              <label class="form-label small">Start Date</label>
              <input
                type="date"
                class="form-control form-control-sm"
                [(ngModel)]="startDate"
              >
            </div>
            <div class="col-6">
              <label class="form-label small">End Date</label>
              <input
                type="date"
                class="form-control form-control-sm"
                [(ngModel)]="endDate"
              >
            </div>
          </div>
        </div>

        <!-- Column Selection (Optional) -->
        <div *ngIf="config.showColumnSelection && config.columns.length > 0">
          <div class="form-check mb-2">
            <input
              class="form-check-input"
              type="checkbox"
              id="includeAllColumns"
              [(ngModel)]="includeAllColumns"
              (change)="toggleAllColumns()"
            >
            <label class="form-check-label" for="includeAllColumns">
              Include all columns
            </label>
          </div>

          <div class="column-selection" *ngIf="!includeAllColumns">
            <label class="form-label small text-muted">Select columns to include:</label>
            <div class="column-list">
              <div
                *ngFor="let column of config.columns"
                class="form-check"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  [id]="'col-' + column.key"
                  [checked]="isColumnSelected(column.key)"
                  (change)="toggleColumn(column.key)"
                >
                <label class="form-check-label" [for]="'col-' + column.key">
                  {{ column.label }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="close()"
          [disabled]="isExporting()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="export()"
          [disabled]="isExporting() || !canExport"
        >
          <span *ngIf="isExporting()" class="spinner-border spinner-border-sm me-1" role="status"></span>
          <i *ngIf="!isExporting()" class="bi bi-download me-1"></i>
          {{ isExporting() ? 'Exporting...' : 'Export' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop Overlay -->
<div
  class="modal-backdrop fade"
  [class.show]="isOpen()"
  *ngIf="isOpen()"
></div>
